import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element }) => {
  const isAuthenticated = localStorage.getItem("userData") !== null;

  return isAuthenticated ? element : <Navigate to="/" />;
};

export default ProtectedRoute;